import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: ${({ $margin }) => $margin || '0'};
`;

const ImageWrapper = styled.div`
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
`;

const Image = styled.img`
  width: 88px;
  height: 88px;
  object-fit: cover;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  border-radius: 4px;
`;

const RemoveButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px;
  background-color: ${({ theme }) => theme.COLOR_BLACK};
  color: ${({ theme }) => theme.COLOR_WHITE};
  border: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
`;

const AddImageButton = styled.label`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 0;
  cursor: pointer;
`;

const HiddenInput = styled.input``;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0;
`;

const StyledImageGallery = {
  Container,
  ImageWrapper,
  Image,
  RemoveButton,
  AddImageButton,
  HiddenInput,
  Footer,
};

export default StyledImageGallery;
